<template>
  <div>
    <div class="tips-section">
      <div class="title">温馨提示：</div>
      <div class="no">1. 本月可开发票只针对服务费以及注册费。</div>
      <div class="no">
        2. 本月产生的服务费以及注册费在下个月二号以后才可以索取发票。
      </div>
      <div class="no">3. 发票基于订单开具，不可拆分开票。</div>
      <div class="no">
        4.智绘网络单张发票金额限额100万，索取金额超过100万将拆分成多张发票开具。
      </div>
    </div>
    <div class="condition-section">
      <div class="cond-row">
        <div class="item">
          <div style="margin-right: 10px">发票类型：</div>
          <Select
            class="height45"
            v-model="searchObj.invoiceType"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in invoiceTypeList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <div style="margin-right: 10px">开具类型：</div>
          <Select
            class="height45"
            v-model="searchObj.issueType"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in issueTypeList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item">
          <Input
            class="height45"
            v-model="searchObj.title"
            placeholder="请输入发票抬头"
            style="width: 300px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="btn-height45"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="btn-height45" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <div class="total rows">
        <span>搜索结果（{{ searchObj.total }}）</span>
        <Button class="btn-height45" @click="onAdd">添加发票信息</Button>
      </div>
      <Table
        class="domain-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="invoiceType" slot-scope="{ row }">
          <span>{{ row.invoiceType | invoiceTypeFilter }}</span>
        </template>
        <template slot="issueType" slot-scope="{ row }">
          <span>{{ row.issueType | issueTypeFilter }}</span>
        </template>
        <template slot="op" slot-scope="{ row }">
          <span
            class="inline-block margin-l-10 color-bbb pointer border-ed1d33 radius-4 padding-v-5 padding-h-10"
            @click="onUpdate(row.id)"
            >编辑</span
          >
        </template>
      </Table>
      <div class="page-tool">
        <Page
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          @on-change="onPageChange"
        />
      </div>
    </div>
    <addInvoiceModal
      :show.sync="addInvoiceModalVisibility"
      :type="addInvoiceModalType"
      :id="addInvoiceModalId"
      @submit-success="onSuccess"
    ></addInvoiceModal>
  </div>
</template>

<script>
import { invoiceCancel, invoiceInfoList } from "api/customer.js";
import addInvoiceModal from "components/invoice/addInvoiceModal.vue";
export default {
  name: "invoice",
  components: {
    addInvoiceModal,
  },
  filters: {
    invoiceTypeFilter(val) {
      let title = "--";
      switch (val) {
        case 0:
          title = "增值税普通发票";
          break;
        case 1:
          title = "增值税专用发票";
          break;
      }
      return title;
    },
    issueTypeFilter(val) {
      let title = "--";
      switch (val) {
        case 0:
          title = "个人";
          break;
        case 1:
          title = "企业";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      invoiceTypeList: [
        {
          label: "增值税普通发票",
          value: 0,
        },
        {
          label: "增值税专用发票",
          value: 1,
        },
      ],
      issueTypeList: [
        {
          label: "个人",
          value: 0,
        },
        {
          label: "类型",
          value: 1,
        },
      ],
      searchObj: {
        issueType: null,
        invoiceType: null,
        title: "",
        page: 1,
        limit: 20,
        total: 0,
      },
      columns: [
        {
          title: "发票抬头",
          key: "title",
          align: "center",
        },
        {
          title: "开具类型",
          slot: "invoiceType",
          align: "center",
        },
        {
          title: "发票类型",
          slot: "issueType",
          align: "center",
        },
        {
          title: "操作",
          ellipsis: true,
          slot: "op",
          align: "center",
        },
      ],
      data: [],
      tableLoading: false,
      addInvoiceModalVisibility: false,
      addInvoiceModalType: 0,
      addInvoiceModalId: "",
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          title: this.searchObj.title,
        };
        this.searchObj.issueType !== -1 &&
          (params.issueType = this.searchObj.issueType);
        this.searchObj.invoiceType !== -1 &&
          (params.invoiceType = this.searchObj.invoiceType);
        this.tableLoading = true;
        const { code, data } = await invoiceInfoList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 时间变化
    handleChange(val) {
      this.searchObj.startAtStr = val;
    },
    // 取消申请
    cancelInvoiceEvent(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消申请此发票吗？</p>",
        onOk: async () => {
          let res = await invoiceCancel({ id });
          res = res.data;
          if (res.code === 200) {
            this.$Message.success("取消成功！");
            this.onPageChange(1);
          }
        },
      });
    },
    // 去详情页面
    onUpdate(id) {
      this.addInvoiceModalVisibility = true;
      this.addInvoiceModalType = 2;
      this.addInvoiceModalId = id;
    },
    // 添加
    onAdd() {
      this.addInvoiceModalVisibility = true;
      this.addInvoiceModalType = 1;
      this.addInvoiceModalId = "";
    },
    // 添加成功
    onSuccess(callback) {
      this.req_getList();
      callback(true);
    },
  },
};
</script>
<style lang="less" scoped>
.tips-section {
  padding: 30px 50px 30px;
  background-color: #fff;
  border-radius: 8px;
  .title {
    color: #333333;
    font-size: 14px;
    font-weight: Bold;
    line-height: 36px;
  }
  .no {
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 36px;
  }
}
.condition-section {
  margin: 15px;
  background-color: #fff;
  padding: 20px 20px;
  .cond-row {
    display: flex;
    flex-wrap: wrap;
    line-height: 60px;
    .item {
      display: flex;
      align-items: center;
      margin: 0 20px;
    }
  }
}
.tname {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.total {
  line-height: 80px;
  font-size: 18px;
  color: #3992e9;
  font-weight: bold;
}
.table-data {
  margin: 40px 0;
  background-color: #fff;
  padding: 20px 20px;
}
.page-tool {
  margin-top: 40px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.domain-table {
  .ivu-table-header th {
    background-color: #315491;
  }
  .ivu-table-header th,
  .ivu-table-body td {
    height: 60px;
  }
  .ivu-table-tip {
    td {
      line-height: 300px;
    }
  }
}
.rows {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>

<style lang="less" scoped>
/deep/.height45 {
  .ivu-input {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-icon {
    line-height: 45px;
  }
  .ivu-input-with-prefix {
    padding-left: 60px;
  }
  .ivu-input-prefix {
    width: 60px;
    padding: 0 10px;
  }
  .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-input {
    height: 45px;
  }
  .ivu-select-selected-value {
    height: 45px;
    line-height: 45px;
  }
  .ivu-select-placeholder {
    height: 45px;
    line-height: 45px;
  }
  .ivu-input-prefix i,
  .ivu-input-suffix i {
    line-height: 45px;
  }
}
.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
